import {Link} from 'react-router-dom';
import {Icon} from '@vidazoo/ui-kit';
import UrlsService from '../../../../common/router/services/urlsService.mdl';
import theme from '../view/theme.module.scss';

export default function DashboardsHeader() {
    return <div className={theme.header}>
        <h1 className={theme.title}><Icon iconName="icon-scenarios" size={3}/>Dashboards</h1>
        <Link className={theme.create} to={UrlsService.createDashboard()}>
            <Icon iconName="icon-plus-small" size={2.4}/>Create Dashboard
        </Link>
    </div>;
}
